import React, { useState } from 'react';

const NAV_ITEMS = [
  { label: 'Home', view: 'home', icon: '🏠' },
  { label: 'Single Qubit', view: 'visualizations', tab: 'single-qubit', icon: '🌊' },
  { label: 'Entanglement', view: 'visualizations', tab: 'entanglement', icon: '🔗' },
  { label: 'Learn', view: 'visualizations', tab: 'learn', icon: '📚' },
  { label: 'Cryptography', view: 'cryptography', icon: '🔐' },
];

export default function Header({ activeView, activeTab, onNavigate }) {
  const [drawerOpen, setDrawerOpen] = useState(false);

  const isActive = (item) => item.view === activeView && (!item.tab || item.tab === activeTab);

  const go = (item) => {
    onNavigate(item.view, item.tab);
    setDrawerOpen(false);
  };

  return (
    <>
    <header className="sticky top-0 z-50 w-full bg-white/95 backdrop-blur-md border-b border-slate-200 shadow-sm">
      <div className="max-w-screen-2xl mx-auto px-3 sm:px-6">
        <div className="py-2 flex items-center justify-between gap-2">
          {/* Left: College brand */}
          <button
            onClick={() => go({ view: 'home' })}
            className="flex items-center gap-2 sm:gap-3 min-w-0 text-left group"
          >
            <img
              src="/swrnandhra-logo.png"
              alt="Swarnandhra College of Engineering & Technology"
              className="w-9 h-9 sm:w-11 sm:h-11 object-contain flex-shrink-0"
            />
            <span className="min-w-0">
              <span className="block text-xs sm:text-sm font-bold text-slate-800 leading-tight truncate group-hover:text-blue-700 transition-colors">
                Swarnandhra College of Engineering &amp; Technology
              </span>
              <span className="hidden sm:block text-[11px] text-slate-500 leading-tight truncate">
                (Autonomous) &middot; Quantum Computing Visualizations
              </span>
            </span>
          </button>

          <div className="flex items-center gap-2 flex-shrink-0">
            {/* AICTE IDEA Lab badge */}
            <div className="flex items-center gap-1.5 sm:gap-2 bg-gradient-to-r from-amber-50 to-orange-50 border border-amber-300 rounded-full pl-1.5 pr-2 sm:pr-3 py-1">
              <span className="w-6 h-6 sm:w-7 sm:h-7 rounded-full bg-gradient-to-br from-purple-500 via-pink-500 to-amber-400 flex items-center justify-center text-xs sm:text-sm flex-shrink-0">
                💡
              </span>
              <span className="leading-tight">
                <span className="block text-[11px] sm:text-xs font-bold text-amber-800 whitespace-nowrap">
                  AICTE IDEA Lab
                </span>
                <span className="hidden md:block text-[9px] text-amber-600 tracking-wide font-semibold whitespace-nowrap">
                  IDEATE &bull; INNOVATE &bull; IMPACT
                </span>
              </span>
            </div>

            {/* Hamburger - mobile/tablet only */}
            <button
              onClick={() => setDrawerOpen(true)}
              className="lg:hidden w-9 h-9 flex-shrink-0 flex items-center justify-center rounded-lg text-slate-700 hover:bg-slate-100 transition-colors"
              aria-label="Open navigation menu"
            >
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                <line x1="3" y1="6" x2="21" y2="6" />
                <line x1="3" y1="12" x2="21" y2="12" />
                <line x1="3" y1="18" x2="21" y2="18" />
              </svg>
            </button>
          </div>
        </div>

        {/* Desktop nav */}
        <nav className="hidden lg:flex items-center justify-center gap-2 pb-2.5">
          {NAV_ITEMS.map((item) => (
            <button
              key={item.label}
              onClick={() => go(item)}
              className={`px-4 py-1.5 rounded-full text-sm font-semibold transition-all ${
                isActive(item)
                  ? 'bg-blue-600 text-white shadow-md'
                  : 'text-slate-600 hover:bg-slate-100 hover:text-blue-700'
              }`}
            >
              <span className="mr-1.5">{item.icon}</span>
              {item.label}
            </button>
          ))}
        </nav>
      </div>
    </header>

      {/* Mobile / tablet drawer */}
      <div
        className={`lg:hidden fixed inset-0 z-[60] transition-opacity duration-300 ${
          drawerOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
        }`}
      >
        <div className="absolute inset-0 bg-black/50" onClick={() => setDrawerOpen(false)} />
        <div
          className={`absolute top-0 left-0 h-full w-72 max-w-[80vw] bg-white shadow-2xl flex flex-col transition-transform duration-300 ${
            drawerOpen ? 'translate-x-0' : '-translate-x-full'
          }`}
        >
          <div className="flex items-center justify-between px-4 py-3 border-b border-slate-200">
            <span className="font-bold text-slate-800">Navigate</span>
            <button
              onClick={() => setDrawerOpen(false)}
              className="w-8 h-8 flex items-center justify-center rounded-lg text-slate-500 hover:bg-slate-100"
              aria-label="Close navigation menu"
            >
              ✕
            </button>
          </div>
          <nav className="flex flex-col gap-1 p-3">
            {NAV_ITEMS.map((item) => (
              <button
                key={item.label}
                onClick={() => go(item)}
                className={`flex items-center gap-3 px-3 py-3 rounded-xl text-left font-semibold transition-all ${
                  isActive(item)
                    ? 'bg-blue-600 text-white shadow-md'
                    : 'text-slate-600 hover:bg-slate-100'
                }`}
              >
                <span className="text-lg">{item.icon}</span>
                {item.label}
              </button>
            ))}
          </nav>
        </div>
      </div>
    </>
  );
}
